import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { AddEventIcon } from "@/assets/widgets/add-event-icon.tsx"
import { ApiaryEventCard } from "@/features/events/apiary-events/components/apiary-event-card/apiary-event-card.tsx"
import { useFilteredApiaryEvents } from "@/features/events/apiary-events/hooks/use-filter-apiary-events.ts"
import {
  APIARY_EVENT_LIST_VIEW,
  NEW_APIARY_EVENT_VIEW,
} from "@/features/events/apiary-events/routes/route-list.ts"
import EmptyContentCreateItemButton from "@/features/home/components/empty-content-create-item-button/empty-content-create-item-button.tsx"
import WidgetHeader from "@/features/home/components/widget-header/widget-header.tsx"

interface Props {}

export const ApiaryEventsSummaryCard: React.FC<Props> = ({}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { events } = useFilteredApiaryEvents()

  const addItemsGoToAction =
    events && events?.length > 0
      ? () => navigate(NEW_APIARY_EVENT_VIEW)
      : undefined

  return (
    <div
      className={
        "widget-border box-border flex w-full flex-col gap-5 bg-white px-4 py-4"
      }
    >
      <WidgetHeader
        title={t("apiaryEvents")}
        navigateTo={APIARY_EVENT_LIST_VIEW}
        icon={<AddEventIcon />}
        addItemGoTo={addItemsGoToAction}
      />
      {events && events?.length > 0 ? (
        <div className={"flex flex-col gap-2"}>
          {events.slice(0, 3).map((event, index) => (
            <ApiaryEventCard event={event} key={index} />
          ))}
        </div>
      ) : (
        <EmptyContentCreateItemButton navigateTo={NEW_APIARY_EVENT_VIEW} />
      )}
    </div>
  )
}
